import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { UploadingIconComponent } from './uploading-icon.component';

@NgModule({
  declarations: [ UploadingIconComponent ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [ UploadingIconComponent ]
})
export class UploadingIconModule { }
